/**
 * Job description cap, shared by the setup form and enforced again by the
 * interview-engine `start` action. The JD is used exactly once — question
 * generation — so 8,000 chars (~2k tokens, once per session) covers essentially
 * every real posting without meaningful prompt cost.
 */
export const JOB_DESCRIPTION_MAX_CHARS = 8000

/** Guard before in-browser PDF/DOCX parsing, which loads the whole file into memory. */
export const JOB_DESCRIPTION_MAX_FILE_BYTES = 5 * 1024 * 1024

/**
 * Interview answer cap, required by docs/SECURITY.md ("enforce max length
 * (answer_text: 5000 chars)"). Enforced client-side here and again server-side
 * before the DB insert — an uncapped answer goes straight into the evaluator
 * prompt, so this is a cost control as much as a validation rule.
 */
export const ANSWER_TEXT_MAX_CHARS = 5000
